/*
Code for the Footer on every Page
*/

export const Footer = () => {
  return (
    <footer>
      <p className="footer_text">Scripps College</p>
    </footer>
  );
};
